import React from "react";
import Bigpromo from "./Sections/Bigpromo";

export default function Bigpromopage() {
  return (
    <div className="container">
      <Bigpromo />
    </div>
  );
}
